import React from 'react'
import "./DotsLoader.css";

const DotsLoaderAnimation = () => {
  return (
    <div className='loader'></div>
  )
}

export default DotsLoaderAnimation